<template>
  <div :class="['collection-frame', themeColor]">
    <div class="label-wrapper">
      <slot name="label"></slot>
    </div>
    <div class="content-wrapper">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: 'blue',
    },
  },
};
</script>
<style lang="scss" scoped>
.collection-frame {
  position: relative;
  height: 140px;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 8px;

  &.red {
    background-image: linear-gradient(179deg, #f15232 8%, #fec9bc 99%);
  }
  &.blue {
    background-image: linear-gradient(to top, #b2e0ff -24%, #46aafc 107%);
  }

  .content-wrapper {
    align-items: center;
  }

  .label-wrapper {
    align-items: center;
    width: 124px;
    height: 20px;
    margin: 6px 6px 9.5px 7px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.65);
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #fff;
    text-transform: uppercase;
  }
}
</style>
